import Immutable from 'immutable';
import React from 'react';

import CheckBox from 'sharedreact/components/CheckBox';
import TableAction from 'sharedreact/components/TableAction';
import TableActions from 'sharedreact/components/TableActions';
import TableContainer from 'sharedreact/containers/TableContainer';
import TableColumn from 'sharedreact/data/TableColumn';
import { translate } from 'sharedreact/utils/LanguageSupport';

import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

type Props = {
  className?: string,
  openIDConfigs: Immutable.List<OpenIDConfig>,
  aesaasLicense: boolean,

  onRemove: (id: string) => void,
  onEdit: (openIDConfig: OpenIDConfig) => void,
  onEnable: (openIDConfig: OpenIDConfig) => void
};

function _getDescriptionString (aesaasLicense: boolean, openIDConfig: OpenIDConfig): string {
  if (openIDConfig.managed) {
    return translate(aesaasLicense ? 'launcher.identityproviders.description.managedbyesko' : 'launcher.identityproviders.description.managed');
  }

  switch (openIDConfig.type) {
    case 'okta': {
      return translate('launcher.identityproviders.oidc.description.okta', openIDConfig.oktahost, openIDConfig.clientId);
    }
    case 'azure': {
      return translate('launcher.identityproviders.oidc.description.azure', openIDConfig.tenantId, openIDConfig.clientId);
    }
    default: {
      return '';
    }
  }
}

class OpenIDConfigTable extends React.Component<Props> {
  constructor (props: Props) {
    super(props);

    this.handleRemove = this.handleRemove.bind(this);
  }

  handleRemove (openIDConfig: OpenIDConfig) {
    this.props.onRemove(openIDConfig.id);
  }

  override render (): React.ReactNode {
    const { className, openIDConfigs, aesaasLicense, onEdit, onEnable
     } = this.props;

    const tableColumns: TableColumn<OpenIDConfig>[] = [
      {
        title: translate('launcher.identityproviders.oidc.enabled'),
        alignCenter: true,
        width: '10%',
        renderCell: (item: OpenIDConfig, row: number, col: number): React.ReactNode =>
        (
          <div className='webappslauncher-enablecheckbox'>
            <CheckBox id={'ae_checkbox_oidc' + row}
              checked={item.enabled}
              label=''
              onChange={(event) => onEnable(item.set('enabled', event.target.checked))}
              disabled={item.managed}
              toolTip={translate('launcher.identityproviders.oidc.enabledtooltip')}
            />
          </div>
        ),
        selectable: true,
        movable: true,
        name: 'enabled'
      }, {
        title: translate('launcher.identityproviders.oidc.name'),
        width: '20%',
        renderCell: (item: OpenIDConfig, row: number, col: number): React.ReactNode => item.name,
        selectable: false,
        movable: true,
        name: 'name'
      }, {
        title: translate('launcher.identityproviders.oidc.type'),
        width: '10%',
        renderCell: (item: OpenIDConfig, row: number, col: number): React.ReactNode => translate('launcher.identityproviders.oidc.' + item.type),
        selectable: true,
        movable: true,
        name: 'type'
      }, {
        title: translate('launcher.identityproviders.oidc.description.title'),
        width: '50%',
        renderCell: (item: OpenIDConfig, row: number, col: number): React.ReactNode => _getDescriptionString(aesaasLicense, item),
        selectable: true,
        movable: true,
        name: 'description'
      }, {
        title: translate('launcher.identityproviders.oidc.actions'),
        width: '10%',
        renderCell: (item: OpenIDConfig, row: number, col: number) => {
          return (!item.managed
            ? <TableActions>
              <TableAction<OpenIDConfig>
                id={'ae_button_oidc_' + item.id + '_edit'}
                className='esko_tableactionedit'
                item={item}
                onClick={onEdit}
              />
              <TableAction<OpenIDConfig>
                id={'ae_buttonoidc_' + item.id + '_remove'}
                className='esko_tableactionremove'
                item={item}
                onClick={this.handleRemove}
              />
            </TableActions>
            : null
          );
        },
        selectable: false,
        movable: true,
        name: 'actions'
      }];

    return (
      <TableContainer<OpenIDConfig>
        className={className}
        id='ae_oidc_config_table'
        tableName='OpenIDConfigTable'
        tableColumns={Immutable.List(tableColumns)}
        rowData={openIDConfigs}
      />
    );
  }
}

export default OpenIDConfigTable;
